import type { AccessContextSnapshot } from '@cdf/api-client-react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type FeatureStage = NonNullable<AccessContextSnapshot['featureStages']>[string];

export const featureStageLabels = {
  available: 'Available',
  preview: 'Frontier',
  deprecated: 'Deprecated',
  hidden: 'Hidden'
} satisfies Record<FeatureStage, string>;

interface FeatureStageBadgeProps {
  stage?: FeatureStage;
  compact?: boolean;
  className?: string;
}

export function FeatureStageBadge({ stage, compact = false, className }: FeatureStageBadgeProps) {
  if (!stage || (compact && stage !== 'preview' && stage !== 'deprecated')) return null;
  const letter = stage === 'preview' ? 'F' : stage === 'deprecated' ? 'D' : null;
  const label = featureStageLabels[stage];
  return (
    <Badge
      variant="outline"
      role={compact ? 'img' : undefined}
      aria-label={compact ? `${label} feature` : undefined}
      title={`${label} feature`}
      className={cn(
        compact && 'size-4 justify-center rounded-full p-0 text-[10px] leading-none',
        stage === 'preview' && 'border-orange-700 bg-orange-700 text-white dark:border-orange-400 dark:bg-orange-400 dark:text-orange-950',
        stage === 'deprecated' && 'border-purple-700 bg-purple-700 text-white dark:border-purple-300 dark:bg-purple-300 dark:text-purple-950',
        className
      )}
    >
      {letter && <span aria-hidden="true" className={cn(!compact && 'font-bold')}>{letter}</span>}
      {!compact && label}
    </Badge>
  );
}
